import React, { useState } from 'react'
import { Field } from 'formik'
import { FieldWrapper, Label } from '../ContentStructure/Components'
import { CustomOption, CustomSingleValue } from '../ContentStructure/Customselect/CustomSelect'
import BaseSelectInput from '../Components/Common/SelectInput'
import BaseButton from '../Components/Common/Button'

const findById = (list, id) =>
  list.find((option) => String(option.id) === String(id)) || null

const CoachingDayItem = ({
  item,
  itemIndex,
  sectionIndex,
  itemList,
  seriesItems,
  getClassListbyPlan,
  setFieldValue,
  errors
}) => {
  const field = (name) => `sections[${sectionIndex}].items[${itemIndex}].${name}`
  const optional = itemIndex >= 5
  const [showDescription, setShowDescription] = useState(
    Boolean(item.description)
  )
  const clearClass = () => {
    setFieldValue(field('series'), '')
    setFieldValue(field('id'), '')
    setFieldValue(field('description'), '')
    setShowDescription(false)
  }

  return (
    <div className='section-item'>
      <div className='section-item-heading'>
        <div className='section-item-title'>
          Class {itemIndex + 1}
          {optional ? ' (optional)' : ''}
        </div>
        <div className='section-item-actions'>
          {optional && (item.series || item.id) && (
            <BaseButton className='btn btn-default' onClick={clearClass}>
              Clear
            </BaseButton>
          )}
          {!showDescription && (
            <BaseButton
              className='btn btn-default'
              onClick={() => setShowDescription(true)}
            >
              + Custom description
            </BaseButton>
          )}
        </div>
      </div>
      <div className='align-items-center'>
        <FieldWrapper>
          <Label>Series</Label>
          <BaseSelectInput
            value={item.series ? findById(seriesItems, item.series) : null}
            name={field('series')}
            options={seriesItems}
            placeholder='Select a series'
            isClearable={optional}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.title}
            onChange={(value) => {
              const seriesId = value?.id || ''
              setFieldValue(field('series'), seriesId)
              setFieldValue(field('id'), '')
              if (seriesId) getClassListbyPlan(seriesId)
            }}
            components={{
              Option: CustomOption,
              SingleValue: CustomSingleValue
            }}
          />
          {errors?.sections?.[sectionIndex]?.items?.[itemIndex]?.series && (
            <div className='text-danger'>Series is required</div>
          )}
        </FieldWrapper>
        <FieldWrapper>
          <Label>Class</Label>
          <BaseSelectInput
            value={item.id ? findById(itemList, item.id) : null}
            name={field('id')}
            options={itemList}
            placeholder='Select a class'
            isClearable={optional}
            disabled={!item.series || itemList.length === 0}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.title}
            onChange={(value) => setFieldValue(field('id'), value?.id || '')}
            components={{
              Option: CustomOption,
              SingleValue: CustomSingleValue
            }}
          />
          {errors?.sections?.[sectionIndex]?.items?.[itemIndex]?.id && (
            <div className='text-danger'>Class is required</div>
          )}
        </FieldWrapper>
      </div>
      {showDescription && (
        <FieldWrapper style={{ marginTop: 12 }}>
          <Label>
            Custom description for this program
            <BaseButton
              className='btn btn-link'
              style={{ marginLeft: 8, padding: 0 }}
              onClick={() => {
                setFieldValue(field('description'), '')
                setShowDescription(false)
              }}
            >
              Remove
            </BaseButton>
          </Label>
          <Field
            as='textarea'
            name={field('description')}
            rows={4}
            placeholder='Shown on class details when the member opens this class from the personalized plan. Leave empty to use the class’s normal description.'
            style={{
              width: '100%',
              padding: 8,
              fontSize: 14,
              border: '1px solid #ccc',
              borderRadius: 8
            }}
          />
        </FieldWrapper>
      )}
    </div>
  )
}

export default CoachingDayItem
